import axios from 'axios';

export const userlogin = (email: string, password: string) => {
    const apiBases = process.env.REACT_APP_API_URL;

    return axios
        .post(apiBases + "/admin/auth/login", {
            email,
            password,
        })
        .then((response: any) => {
            if (response.data.accessToken) {
                // console.log(response, 'afterlogin');
                localStorage.setItem('accessToken', response.data.accessToken);
            }
            return response.data;
        });
};

export const emailcredentials = (email: string) => {
    return email.trim();
};

export const isLogin = () => {
    if (localStorage.getItem('accessToken')) {
        return true;
    }

    return false;
}